import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Flex, Select } from 'antd';
import ReactApexChart from 'react-apexcharts';
const SalesOrder = ({ dataSales, t }) => {
  const { darkMode } = useSelector((state) => state.user);
  const { sales_order_dist, sales_order_header } = dataSales || {};
  const seriesChart = sales_order_dist?.map((item) => item.count) || [];
  const optionsChart = {
    chart: {
      type: 'pie',
    },
    stroke: {
      show: true,
    },
    // title: {
    //   text: t.TopProduct_Type,
    // },
    legend: {
      position: 'bottom',
    },
    labels: sales_order_dist?.map((item) => item.status) || [],
    // colors: ['#AB268D', '#237598', '#d65147', '#1AA1D1', '#687cfe'],
    colors: ['#0b9640', '#4dd4b7', '#d65147', '#1AA1D1', '#687cfe'],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };
  return (
    <Card
      style={{ width: '100%', height: '100%' }}
      className="card-graph-dashboard-revenue"
      title={
        <Flex justify="space-between" align="center">
          <h3
            style={{
              fontSize: '16px',
              margin: '0 0 7px 0',
              fontWeight: 600,
              color: '#495057',
            }}
          >
            {t.SalesOrder}
          </h3>
        </Flex>
      }
    >
      <div
        className={
          darkMode
            ? 'dark-chart fex items-center justify-center'
            : 'fex items-center justify-center'
        }
      >
        <div className="bg-[#e9ebec8c] grid  gap-2 grid-cols-3 lg:grid-cols-5 xxl:grid-cols-5 px-[20px] text-center">
          <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
            <h2 className="text-[#495057] font-[600] text-[17px]">
              {sales_order_header[0]?.total_sales_order_count}{' '}
              {/* <span className="text-[10px] font-[400] text-[#878a99]">
                {t.SAR}
              </span> */}
            </h2>
            <p className="text-[#878a99] font-[500] text-[14px]">{t.Count}</p>
          </div>
          <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
            <h2 className="text-[#495057] font-[600] text-[17px] flex items-center gap-1">
              {sales_order_header[0]?.total_sales_order_amount}{' '}
              <span className="text-[10px] font-[400] text-[#878a99]">
                {t.SAR}
              </span>
            </h2>
            <p className="text-[#878a99] font-[500] text-[14px]">{t.Amount}</p>
          </div>

          <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
            <h2 className="text-[#495057] font-[600] text-[17px] flex items-center gap-1">
              {sales_order_header[0]?.total_sales_order_advance}
              <span className="text-[10px] font-[400] text-[#878a99]">
                {t.SAR}
              </span>
            </h2>
            <p className="text-[#878a99] font-[500] text-[14px]">{t.Advance}</p>
          </div>

          <div className="border-r-[1px] border-[#e4e7e9] border-dashed p-4">
            <h2 className="text-[#495057] font-[600] text-[17px] flex items-center gap-1">
              {sales_order_header[0]?.total_sales_order_tax}{' '}
              <span className="text-[10px] font-[400] text-[#878a99]">
                {t.SAR}
              </span>
            </h2>
            <p className="text-[#878a99] font-[500] text-[14px]">{t.Tax}</p>
          </div>
          <div className=" border-[#e4e7e9] border-dashed p-4">
            <h2 className="text-[#495057] font-[600] text-[17px]">
              {sales_order_header[0]?.total_sales_order_discount}{' '}
              <span className="text-[10px] font-[400] text-[#878a99]">
                {t.SAR}
              </span>
            </h2>
            <p className="text-[#878a99] font-[500] text-[14px]">
              {t.discount}
            </p>
          </div>
        </div>
        <div id="chart" className="p-[20px]">
          <ReactApexChart
            options={optionsChart}
            series={seriesChart}
            type="pie"
            // width={300}
            height={310}
          />
        </div>
        <div id="html-dist"></div>
      </div>
    </Card>
  );
};

export default SalesOrder;
